import { Virtuoso } from 'react-virtuoso';
import useBoundStore from '../../../../store';
import Loader from '../../../../components/loader';
import NotFound from '../../../../components/not-found';
import RadioButton from '../../../../components/radio-button';
import styles from './styles.module.scss';
import { ComponentType } from "react";

export type TBuildingStreetWrapper = {
  address: string;
  id: number;
  facilityCount: number;
};

interface StreetTabProps {
  changeFacilityCount: React.Dispatch<React.SetStateAction<number | undefined>>;
  buildings: TBuildingStreetWrapper[];
  isLoading: boolean;
  houseId: number | undefined;
  setHouseId: React.Dispatch<React.SetStateAction<number | undefined>>;
  setFacilityCount: React.Dispatch<React.SetStateAction<number | undefined>>;
  footer?: ComponentType
}

const StreetTab: React.FC<StreetTabProps> = (props: StreetTabProps) => {
  const { buildings, isLoading, setHouseId, setFacilityCount, houseId } = props;
  const setSelectedSellBuildingSecondary = useBoundStore((s) => s.setSelectedSellBuildingSecondary);

  return (
    <div className={styles.tabContainerList}>
      {buildings.length > 0 ? (
        <Virtuoso
          useWindowScroll
          data={buildings}
          style={{ height: '100%' }}
          components={{
            Footer: props.footer,
          }}
          itemContent={(idx, house) => {
            return (
              <RadioButton
                label={house.address}
                className={styles.itemStreetList}
                labelPosition='left'
                checked={house?.id === houseId}
                onChange={() => {
                  setHouseId((prev) => (prev === house?.id ? undefined : house?.id));
                  // @ts-ignore
                  setFacilityCount((prev: number) =>
                    prev === house?.facilityCount ? undefined : house?.facilityCount,
                  );
                  setSelectedSellBuildingSecondary({ id: house?.id, title: house.address });
                }}
              />
            );
          }}
        />
      ) : isLoading ? (
        <Loader />
      ) : (
        <NotFound />
      )}
    </div>
  );
};

export default StreetTab;
